import { List } from 'immutable';
import { RecipeCategories } from 'records/RecipeCategory';
import BaseList from 'records/BaseList';

import {
  RECIPE_CATEGORIES_ASYNC_ACTION_START,
  RECIPE_CATEGORIES_ASYNC_ACTION_ERROR,
  RECIPE_CATEGORIES_ASYNC_UPDATE_SUCCESS,
  RECIPE_CATEGORIES_RESET_STATE,
} from 'actions/recipeCategories';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [RECIPE_CATEGORIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPE_CATEGORIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPE_CATEGORIES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const recipeCategoriesData = RecipeCategories(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: recipeCategoriesData,
    });
  },
  [RECIPE_CATEGORIES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function recipeCategories(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
